export default "__VITE_ASSET__CXhXkyoX__"